import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import FeedbackForm from "./pages/FeedbackForm";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import PendingReviews from "./pages/PendingReviews";
import GuestSearch from "./pages/GuestSearch";

function Loader() {
  return (
    <div className="min-h-screen grid place-items-center" data-testid="app-loading">
      <div className="h-10 w-10 rounded-full border-2 border-emerald-700 border-t-transparent animate-spin" />
    </div>
  );
}

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/feedback" replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/dashboard" : "/feedback"} replace />;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/feedback" element={<Protected><FeedbackForm /></Protected>} />
            <Route path="/pending" element={<Protected><PendingReviews /></Protected>} />
            <Route path="/search" element={<Protected><GuestSearch /></Protected>} />
            <Route path="/dashboard" element={<Protected admin><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
